import Headroom from 'headroom.js';
import dropdownEvent from '../base/_dropdownEvent.js';

export default class Masthead {
	constructor(node = '.masthead', opts = {}) {
		this.node = typeof node === 'string' ? document.querySelector( node ) : node;

		if ( ! this.node instanceof HTMLElement ) {
			return;
		}

		const mastheadOverlapClass = this.node.classList.contains('masthead--overlaps-header') ? ' has-dark-background-color': '';

		this.opts = Object.assign(
			{
				headroom: {
					tolerance: {
						up: 7,
						down: 5
					},
					classes: {
						initial  : 'masthead',
						pinned   : 'masthead--pinned',
						unpinned : 'masthead--unpinned',
						top      : 'masthead--top' + mastheadOverlapClass,
						notTop   : 'masthead--not-top',
						bottom   : 'masthead--bottom',
						notBottom: 'masthead--not-bottom',
						frozen   : 'masthead--frozen',
					}
				},
				search: '.masthead__search',
				menu: '.masthead__menu',
				classes: {
					bodyOpened: "menu-fixed",
					searchActive: "masthead__search--active",
					subMenuActive: "nav__menu-item--active",
					menuActive: "masthead-menu--active",
				}
			},
			opts
		);
		this.classes = this.opts.classes;

		if ( typeof this.opts.headroom === 'object' ) {
			// headroom
			this.headroom = new Headroom(this.node, this.opts.headroom);
			this.headroom.init();
			this.headroom.update(this.headroom);
		}

		this.search    = typeof this.opts.search === 'string' ? this.node.querySelector(this.opts.search) : this.opts.search;
		this.hamburger = typeof this.opts.menu   === 'string' ? this.node.querySelector(this.opts.menu)   : this.opts.menu;
		this.subMenuToggle = this.node.querySelectorAll(".nav__menu-toggle");
		this.searchBtn = this.node.querySelectorAll(".masthead__search");

		this.isGreater992 = document.body.clientWidth >= 992;
		let matchMedia = window.matchMedia("(min-width: 992px)");
		matchMedia.addEventListener("change", () => {
			this.isGreater992 = document.body.clientWidth >= 992;
		});

		this.desktopMenu();

		if( this.node.classList.contains('is-style-inline') ) {
			this.node.addEventListener('click', (e) => {
				let node = e.target;

				while( node && node.parentNode ) {
					if ( node === this.node ) {
						return;
					}

					if ( node.matches( '.nav__menu--level-1 .menu-item-has-children > .nav__link' ) ) {
						e.preventDefault();
					}

					node = node.parentNode;
				}
			});

			//menu functions
			const openMenu = () => {
				closeSearch();
				document.body.classList.add(this.classes.bodyOpened);
				this.node.classList.add(this.classes.menuActive);
				this.previousActiveElement = document.activeElement;
			};

			const closeMenu = () => {
				this.node.classList.remove(this.classes.menuActive);
				document.body.classList.remove(this.classes.bodyOpened);
				if (this.previousActiveElement) {
					this.previousActiveElement.focus();
				}
			};

			//search functions
			const openSearch = () => {
				closeMenu();
				this.node.classList.add(this.classes.searchActive);
				this.node.querySelector(".searchform__input").focus();
			};

			const closeSearch = () => {
				this.node.classList.remove(this.classes.searchActive);
			};

			const handleCloseMenu = () => {
				const header = document.querySelector(".header-menu--active");
				if (header) closeMenu(header);
			};

			// handle esc/tab keys
			this.handleKeyup = (e) => {
				const { activeElement } = document;
				if (e.key === "Escape") {
					const openNode = activeElement.closest("[data-open-node]");

					if (activeElement === this.hamburger) {
						handleCloseMenu();
						return false;
					}
					switch (openNode?.dataset.openNode) {
						case "search": {
							closeSearch(openNode);
							break;
						}
						case "nav": {
							handleCloseMenu();
							break;
						}
						case "submenu": {
							openNode.parentElement.classList.remove(this.classes.subMenuActive);
							break;
						}
						default: {
							break;
						}
					}
				} else {
					const activeSub = this.node.querySelector(
						`.${this.classes.subMenuActive}`
					);
					if (
						activeSub &&
						activeSub !== activeElement &&
						!activeSub.contains(activeElement)
					) {
						activeSub.classList.remove(this.classes.subMenuActive);
					}
				}
			};

			//main menu toggle (mobile)
			this.hamburger.addEventListener("click", () => {
				if (this.node.classList.contains(this.classes.menuActive)) {
					closeMenu();
				} else {
					openMenu();
				}
			});

			this.searchBtn.forEach((search) => {
				search.addEventListener("click", () => {
					if (this.node.classList.contains(this.classes.searchActive)) {
						closeSearch();
					} else {
						openSearch();
					}
				});
			});

			this.subMenuToggle.forEach((submenu) => {
				submenu.addEventListener("click", () => {
					if (!this.isGreater992) {
						const menuItem = submenu.closest("[data-level='0']");
						const currentActive = document.querySelector(
							`.${this.classes.subMenuActive}`
						);

						if (menuItem.classList.contains(this.classes.subMenuActive)) {
							menuItem.classList.remove(this.classes.subMenuActive);
						} else {
							if (menuItem !== currentActive)
								currentActive?.classList.remove(this.classes.subMenuActive);
							menuItem.classList.add(this.classes.subMenuActive);
						}
					}
				});
			});
		}
	}

	desktopMenu() {
		// dropdowns
		const intentActivate = (e) => {
			Array.from( e.target.children ).filter( node => node.classList.contains( 'nav__menu' ) ).forEach( node => node.classList.add( 'nav__menu--visible') );
		}

		const intentDeactivate = (e) => {
			Array.from( e.target.children ).filter( node => node.classList.contains( 'nav__menu' ) ).forEach( node => node.classList.remove( 'nav__menu--visible') );
		}

		Array.from(this.node.querySelectorAll(".nav__menu-item--has-children")).forEach(
			(node) => {
				dropdownEvent(node);
				node.addEventListener("dropdown:activate", intentActivate);
				node.addEventListener("dropdown:deactivate", intentDeactivate);
			}
		);
	}
}
// if mobile and switch to 992, and nav was open, need to remove fixed body class, remove nav--opened class, remove nav__content--opened
